module.exports = __webpack_public_path__ + "media/images/fav-1ac5c7303a3f54fbc82ff6ca0d54b6aa.svg";